import { render } from "./InputPhoneComponent.vue?vue&type=template&id=4b9cda6b&scoped=true"
import script from "./InputPhoneComponent.vue?vue&type=script&lang=js"
export * from "./InputPhoneComponent.vue?vue&type=script&lang=js"

import "./InputPhoneComponent.vue?vue&type=style&index=0&id=4b9cda6b&scoped=true&lang=css"

import exportComponent from "/var/www/vhosts/dev.soft.team/www/autoringen2/autoringen2.dev.soft.team/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b9cda6b"],['__file',"resources/themes/default/js/components/InputPhoneComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4b9cda6b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4b9cda6b', __exports__)) {
    console.log('reload')
    api.reload('4b9cda6b', __exports__)
  }
  
  module.hot.accept("./InputPhoneComponent.vue?vue&type=template&id=4b9cda6b&scoped=true", () => {
    console.log('re-render')
    api.rerender('4b9cda6b', render)
  })

}


export default __exports__